export const ANSWER_OPTIONS = {
  YES: 'yes',
  PARTLY: 'partly',
  NO: 'no',
  DONT_KNOW: 'dont_know',
  NOT_APPLICABLE: 'not_applicable'
};

const LEVELS = ['ML1', 'ML2', 'ML3'];

export const READINESS_WARNING = 'E8 Light is a self-reported readiness check, not a formal Essential Eight assessment. It does not determine or confirm an ASD maturity level. Results identify areas that require validation during a formal assessment. E8 Tracker is not endorsed or certified by the Australian Signals Directorate.';

export const OUTCOME_PRESENTATION = {
  'Potentially aligned': { colour: '#0F766E', marker: 'A' },
  'Potential gap': { colour: '#B91C1C', marker: 'G' },
  'Evidence required': { colour: '#B45309', marker: 'E' },
  'Claimed not applicable': { colour: '#6D28D9', marker: 'N' },
  'Not answered': { colour: '#64748B', marker: 'U' }
};

export const mapReadinessAnswer = (answer) => {
  if (answer === ANSWER_OPTIONS.YES) return 'Potentially aligned';
  if (answer === ANSWER_OPTIONS.PARTLY || answer === ANSWER_OPTIONS.NO) return 'Potential gap';
  if (answer === ANSWER_OPTIONS.DONT_KNOW) return 'Evidence required';
  if (answer === ANSWER_OPTIONS.NOT_APPLICABLE) return 'Claimed not applicable';
  return 'Not answered';
};

export const isNotApplicableReasonValid = (reason) => Boolean(reason && reason.trim());

export const getCumulativeQuestions = (questionsByStrategy, maturityLevel) => {
  const maxLevel = LEVELS.indexOf(maturityLevel);
  if (maxLevel < 0) return [];

  return Object.entries(questionsByStrategy).flatMap(([strategy, levels]) =>
    LEVELS.slice(0, maxLevel + 1).flatMap((level) =>
      (levels[level] || []).map((question) => ({ ...question, strategy }))
    )
  );
};

export const buildReadinessSummary = (questions, responses = {}) => {
  const outcomes = {
    'Potentially aligned': 0,
    'Potential gap': 0,
    'Evidence required': 0,
    'Claimed not applicable': 0,
    'Not answered': 0
  };
  const strategyMap = new Map();

  questions.forEach((question) => {
    const outcome = mapReadinessAnswer(responses[question.id]?.answer);
    outcomes[outcome] += 1;
    const strategy = strategyMap.get(question.strategy) || {
      name: question.strategy,
      total: 0,
      completed: 0,
      outcomes: { ...outcomes, ...Object.fromEntries(Object.keys(outcomes).map((key) => [key, 0])) }
    };
    strategy.total += 1;
    if (outcome !== 'Not answered') strategy.completed += 1;
    strategy.outcomes[outcome] += 1;
    strategyMap.set(question.strategy, strategy);
  });

  return {
    total: questions.length,
    completed: questions.length - outcomes['Not answered'],
    outcomes,
    strategies: [...strategyMap.values()]
  };
};
